<div class="NgxEditor__Wrapper" [ngClass]="{ 'invalid-field': control.invalid && (control.touched || submitted) }">
    <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
    <ngx-editor [placeholder]="placeholder" [formControl]="control"
        [ngClass]="{ 'is-invalid': control.invalid && (control.touched || submitted) }" [editor]="editor">
        <div class="char-count" [ngClass]="{ 'invalid-char-count': control.errors?.['maxlength'] }">
            {{ getTextWithoutHtml(control.value).length || 0 }}/{{ maxLength }}
        </div>
    </ngx-editor>
    <div *ngIf="control.invalid && (control.touched || submitted)" class="invalid-feedback" style="margin-top: 2px;">
        <div *ngIf="control.errors?.['required']">{{ errorMessage }}</div>
    </div>
    <div *ngIf="control.errors?.['maxlength']" class="invalid-feedback" style="margin-top: 2px;">
        Maximum length of {{ maxLength }} characters exceeded
    </div>
</div>